import i18n from 'modules/core/lib/i18n'

import { usePrivateIntegrationsSyncContext } from 'modules/integrations/hooks/SyncContext'

export const useLastSyncRunLabels = () => {
  const { capabilityMode } = usePrivateIntegrationsSyncContext()
  const isExportMode = capabilityMode === 'file'

  const syncingLabel = () =>
    isExportMode
      ? i18n.t('integrations.exportable_status.exporting')
      : i18n.t('integrations.syncable_status.syncing')

  const lastSyncLabel = () =>
    isExportMode
      ? i18n.t('integrations.footer.last_export')
      : i18n.t('integrations.footer.last_sync')

  const noLastSyncLabel = () =>
    isExportMode
      ? i18n.t('integrations.footer.no_last_export')
      : i18n.t('integrations.footer.no_last_sync')

  return { syncingLabel, lastSyncLabel, noLastSyncLabel }
}
